export const LOAD_DASHBOARD_DATA = 'LOAD_DASHBOARD_DATA';
export const LOAD_DASHBOARD_DATA_SUCCESS = 'LOAD_DASHBOARD_DATA_SUCCESS';
export const LOAD_DASHBOARD_DATA_FAILED = 'LOAD_DASHBOARD_DATA_FAILED';
